import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { useCreateGroupe } from "../../../hooks/useCreateGroupe";
import { customSelectStyles } from '../../../utils/reactSelectStyles';
import { useColors } from "../../../hooks/COLORS/useColors";

const NewGroup = ({ showNewGroup, setShowNewGroup }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState({ nom: '', couleur: null });

    const { mutateAsync: createGroupe } = useCreateGroupe();
    const { data: colorsData } = useColors();

    const colors = colorsData?.data?.map(c => ({ value: c.id, label: c.name, hex: c.hex })) || [];

    const handleSubmitForm = async (e) => {
        e.preventDefault();
        if (!formData.nom || !formData.couleur) {
            alert("Veuillez remplir tous les champs");
            return;
        }
        setIsSubmitting(true);
        try {
            await createGroupe({ nom: formData.nom, couleur: parseInt(formData.couleur.value) });
            setFormData({ nom: '', couleur: null });
            setShowNewGroup(false);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal show={showNewGroup} onHide={() => setShowNewGroup(false)} size="lg">
            <Form onSubmit={handleSubmitForm}>
                <Modal.Header closeButton>
                    <Modal.Title><h5 className="modal-title text-group">Nouveau groupe</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className="mb-3">
                        <Col>
                            <Form.Label className='text-muted'>Nom du groupe</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Nom du groupe"
                                value={formData.nom}
                                onChange={(e) => setFormData({ ...formData, nom: e.target.value })}
                                required
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Form.Group className='mb-3' as={Col} controlId="idCouleur">
                            <Form.Label className='text-muted'>Choisissez une couleur</Form.Label>
                            <Select
                                options={colors}
                                value={formData.couleur}
                                styles={customSelectStyles}
                                placeholder="Sélectionnez une couleur"
                                onChange={(opt) => setFormData(prev => ({ ...prev, couleur: opt }))}
                                formatOptionLabel={(opt) => (
                                    <div className="d-flex align-items-center gap-2">
                                        <div style={{ width: 16, height: 16, borderRadius: "50%", backgroundColor: opt.hex, border: "1px solid #dee2e6", flexShrink: 0 }} />
                                        {opt.label}
                                    </div>
                                )}
                            />
                        </Form.Group>
                        <Form.Group className='mb-3' as={Col} controlId="previsuCouleur">
                            <Form.Label className='text-muted'>Prévisualisation</Form.Label>
                            <div style={{ height: '38px', border: '1px solid #ced4da', borderRadius: '0.375rem', backgroundColor: formData.couleur ? formData.couleur.hex : '#e9ecef' }} />
                        </Form.Group>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" disabled={isSubmitting} onClick={() => setShowNewGroup(false)}>Annuler</Button>
                    <Button variant="primary" type="submit" disabled={isSubmitting}>
                        {isSubmitting ? 'Chargement...' : 'Créer'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default NewGroup;